import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {AuthService} from "./auth.service";

import "rxjs/operator/map";
import {User} from "../definitions";


@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private authService: AuthService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.authenticated()
      .map((user: User): boolean => {
        if (!user) {
          this.router.navigate(["/login"]);
        }
        return true;
      });
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/auth-guard.service.ts